import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ReportThankYouPageRoutingModule } from "./report-thank-you-routing.module";
import { ReportThankYouPage } from "./report-thank-you.page";
import { TranslateModule } from "@ngx-translate/core";
import { ReportKpiComponentModule } from "src/app/components/report-kpi/report-kpi.module";
import { ToDataDefinitionModule } from "src/app/pipes/to-data-definition/to-data-definition.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportThankYouPageRoutingModule,
    TranslateModule,
    ReportKpiComponentModule,
    ToDataDefinitionModule,
  ],
  declarations: [ReportThankYouPage],
})
export class ReportThankYouPageModule {}
